/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {FC, useState, useEffect, Fragment} from 'react'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../_metronic/layout/core'
import ProfileTeaser from '../../modules/profile/ProfileTeaser'
import PublicationsTeaser from '../../modules/publications/PublicationsTeaser'
import PublicationsTeamTeaser from '../../modules/publications/PublicationsTeamTeaser'
import {PendingPubli} from '../../modules/publications/components/Publications'
import CVTeaser from '../../modules/cv/CVTeaser'
import {UserModel} from '../../modules/auth/models/UserModel'
import {UserCvModel} from '../../modules/profile/models/UserCv'
import {GetUserCV} from '../../modules/profile/components/Profile'
import {shallowEqual, useSelector, useDispatch} from 'react-redux'
import {RootState} from '../../../setup'
import {createBlankCv} from '../../modules/profile/components/Profile'
import {actions} from '../../modules/auth/redux/AuthRedux'

const DashboardWrapper: FC = () => {
    const intl = useIntl()
    const user: UserModel = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as UserModel
    const cv: UserCvModel = useSelector<RootState>(({auth}) => auth.cv, shallowEqual) as UserCvModel

    const dispatch = useDispatch()
    const [isLoading, setLoading] = useState(true);

    useEffect(() => {
        const createCvBase = async() =>{
            try {
                await createBlankCv(user.username, user.id)
            } catch (error) {
                console.error(error)
            }
        }

        const refreshCv = async() => {
            try{
                const {data: cv} = await GetUserCV()
                dispatch(actions.fulfillCv(cv))
            } catch (error){
                console.error(error)
            } finally {
                setLoading(false)
            }
        }

        if(user.role === 'chercheur') {
            if(cv.id){
                refreshCv()
            }
            else{
                createCvBase()
                refreshCv()
            }
        }
        else{
            setLoading(false)
        }
    }, [user.role, cv.id, user.username, dispatch, user.id]);

    if (isLoading) {
        return <div className="App">Loading...</div>;
    }

    //console.log('USER INFO', user)
    //console.log('CV INFO', cv)
    return (
        <>
            <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'MENU.DASHBOARD'})}</PageTitle>
            {user.role === 'administrator' ?
                <CVTeaser />
            :
                <Fragment>
                    <ProfileTeaser />
                    <PublicationsTeaser />
                    {user.role === 'manager' && <PublicationsTeamTeaser/>}
                    { /* user.role === 'chercheur' && <PendingPubli/> */}
                </Fragment>
            }

        </>
    )
}

export {DashboardWrapper}
